import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getMeasuresList, hideMeasure, getMeasuresListOnSelect } from '../../../config/services/measures';
import {
    Container, InputAdornment, Stack, Box, List, ListItem, ListItemIcon, ListItemText, TextField, Typography, DialogActions, Button, CircularProgress, Alert, MenuItem, Select, InputLabel,
    Pagination, Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Modal, Fade, Autocomplete
} from "@mui/material";
import Page from "../../../components/Page";
import { ReactComponent as SearchIcon } from "../../../assets/icons/icon_search.svg"
import { makeStyles } from '@mui/styles';
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"
import ColumnsTable from './ColumnsTable';
import toast from 'react-hot-toast';

const options = [
    { value: 'all', label: 'All' },
    { value: 'isHidden', label: 'Hidden Temporarily' },
    { value: 'joinHiddenField', label: 'Hidden Permanently' },
];

const style = {

    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    boxShadow: '0px 0px 4px #0000001A',
    p: 4,
    borderRadius: '4px',
};


const useStyles = makeStyles((theme) => ({

    autoCompleteInp: {
        fontWeight: 'normal'
    },
    searchFieldListItem: {
        paddingTop: '0.6rem',
        paddingBottom: '0.6rem',
        '&:hover': {
            background: "#f1f1f1",
            zIndex: 9,
            "& $listItemDescription": {
                visibility: 'visible'
            },
            "& $searchFieldListMoreIcon": {
                visibility: 'visible'
            }
        },

    }
}));

const ManageDataset = () => {

    const { datasetId } = useParams();
    const [measureList, setMeasureList] = useState([])
    const [searchMeasure, setSearchMeasure] = useState(null)
    const [totalCount, setTotalCount] = useState(0)
    const [pageNo, setPagination] = useState(1)
    const [sortObj, setSortObj] = useState({ sortKey: 'displayName', sortOrder: '1' })
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [search, setSearchValue] = useState('')
    const [loader, setLoader] = useState(false)
    const [value, setValue] = useState(options[0].label);
    const [journeyModel, setJourneyModel] = useState(false)
    const [measureDetails, setMeasureDetails] = useState({})
    const [deactivateStatus, setDeactivateStatus] = useState()
    const classes = useStyles()
    const [checkboxValue, setCheckboxValue] = useState('');
    const [isHidden, setIsHidden] = useState(false);
    const [joinHiddenField, setJoinHiddenField] = useState(false);
    const [unhideTemp, setUnhideTemp] = useState(true)
    const [unhidePerm, setUnhidePerm] = useState(true)
    const [row, setRow] = useState({})


    let totalPages = Number((totalCount / itemsPerPage).toFixed(0))

    const fetchMeasureList = () => {
        const selectedOption = options.filter(option => {
            return option?.label == value
        })[0]
        if (datasetId) {
            let params = { dataSetId: datasetId, search: searchMeasure, pageNo: (pageNo - 1), count: itemsPerPage, sortKey: 'displayName', sortOrder: 1, hidden: selectedOption?.value }
            setLoader(true)
            getMeasuresListOnSelect(params)
                .then((res) => {
                    setMeasureList(res?.result)
                    setTotalCount(res?.totalCount)
                    setLoader(false)
                });
        }
    }

    const handlePagination = (e, pageNumber) => {
        setPagination(pageNumber)
    }


    const handleSearchMeasure = (e) => {
        let { value } = e.target
        setPagination(1)
        setSearchMeasure(value, () => setPagination(1))

    }

    const handleOnChange = (event, newValue) => {
        setValue(newValue?.label);
    };

    const handleMeasureHide = (e, measureDetails) => {
        let { _id } = measureDetails
        hideMeasure({ _id, isHidden, unhideTemp, joinHiddenField, unhidePerm })
            .then(res => {
                if (res?.result) {
                    fetchMeasureList()
                    toast.success(res?.message)

                }
                else if (res?.data?.statusCode === 0) {
                    let { errorMessage } = res?.data?.error
                    toast.error(errorMessage)
                }
                else {
                    console.error(res);
                }
            })
    }

    const toogleHideModal = (data) => {
        setRow(data)
        setJoinHiddenField(false)
        setIsHidden(false)
        setUnhidePerm(true)
        setUnhideTemp(true)
        setCheckboxValue('')
        setJourneyModel(!journeyModel)

    }


    const handleSubmit = (e, measureDetails) => {
        setMeasureDetails(measureDetails)
        setDeactivateStatus(measureDetails.isHidden)
        if (journeyModel) {
            handleMeasureHide(e, measureDetails)
            toogleHideModal()

        }
    }

    const handleRadioChange = (event) => {
        const isChecked = event.target.checked;
        const value = event.target.value;
        setCheckboxValue(value);

        if (value === "isHidden" && isChecked) {
            setIsHidden(true)
            setJoinHiddenField(false)
        }

        else if (value === "joinHiddenField" && isChecked) {
            setJoinHiddenField(true)
            setIsHidden(false)
        }
        else if (value === "unhideisHidden" && isChecked) {
            setUnhideTemp(false)
            setUnhidePerm(true)
        }
        else if (value === "unhidejoinHiddenField" && isChecked) {
            setUnhidePerm(false)
            setUnhideTemp(true)
        }
    };

    const renderOption = (row) => {
        if (value === "All") {
            if (row?.isHidden && !row?.joinHiddenField)
                return (
                    <FormControlLabel className="mr-2" value="joinHiddenField" control={<Radio />} label="Hide Permanently" />
                )
            else if (!row?.isHidden && row?.joinHiddenField)
                return (
                    <FormControlLabel className="mr-2" value="isHidden" control={<Radio />} label="Hide Temporarily" />
                )
            else if (!row?.isHidden && !row?.joinHiddenField) {
                return (
                    <>
                        <FormControlLabel className="mr-2" value="isHidden" control={<Radio />} label="Hide Temporarily" />
                        <FormControlLabel className="mr-2" value="joinHiddenField" control={<Radio />} label="Hide Permanently" />
                    </>
                )
            }
            else if (row?.isHidden && row?.joinHiddenField) {
                return (
                    <>
                        <FormControlLabel className="mr-2" value="unhideisHidden" control={<Radio />} label="Unhide Temporarily" />
                        <FormControlLabel className="mr-2" value="unhidejoinHiddenField" control={<Radio />} label="Unhide Permanently" />
                    </>
                )
            }

        }
    }


    useEffect(() => { fetchMeasureList() }, [datasetId, searchMeasure, pageNo, itemsPerPage, value]);
    return (
        <div>
            <Page title="Extramarks | Datasets " className="main-container datasets_container">
                <Container className='table_max_width'>
                    <Grid container alignItems="left" justifyContent="flex-start" mb={2} spacing={2.5} >
                        <Grid item xs={12} sm={6} md={6} lg={6} className="datasets_header" >
                            <TextField
                                className={`inputRounded search-input`}
                                type="search"
                                placeholder="Search by Dataset name"
                                onChange={handleSearchMeasure}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} >
                            <Grid container justifyContent="center" spacing={2.5}>
                                <Grid>
                                    <Autocomplete
                                        className="cm_rprt_setting_content report_form_ui_input_select pl-0 report_search_visual_dataset "
                                        style={{ width: '200px', marginTop: '20px' }}
                                        classes={{ input: classes.autoCompleteInp }}
                                        size='small'
                                        ListboxProps={{
                                            className: "visual-dataset-list"
                                        }}
                                        disablePortal
                                        disableClearable
                                        popupIcon={<Box className="form_icon"><DropDownIcon /></Box>}
                                        value={value}
                                        options={options}
                                        onChange={handleOnChange}
                                        renderInput={(params) => <TextField {...params} />}
                                    />

                                </Grid>
                            </Grid>
                        </Grid>

                        {measureList?.length ? <ColumnsTable list={measureList}
                            pageNo={pageNo} itemsPerPage={itemsPerPage} setLoader={setLoader} handleSubmit={handleSubmit} toogleHideModal={toogleHideModal} value={value} /> :
                            <Alert severity="error">No Content Available!</Alert>}
                    </Grid>
                </Container>

                <div className='center cm_pagination'>
                    <Pagination count={totalPages} variant="outlined" color="primary" onChange={handlePagination} page={pageNo} />
                </div>

            </Page>

            {journeyModel &&

                <Modal
                    open={toogleHideModal}
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal-paper"
                >

                    <Box sx={style} className="modalContainer" style={{ height: '150px', width: '500px' }}>

                        <RadioGroup
                            row
                            aria-labelledby="addToReportType"
                            name="addToReportType-group"
                            className='form-radio-group'
                            value={checkboxValue}
                            onChange={handleRadioChange}

                        >
                            {
                                renderOption(row)
                            }

                            {value === "Hidden Temporarily" && row?.isHidden ?
                                <div>
                                    <FormControlLabel className="mr-2" value="unhideisHidden" control={<Radio />} label="Unhide Temporarily" />
                                </div>
                                :
                                <>
                                </>
                            }

                            {value === "Hidden Permanently" && row?.joinHiddenField ?
                                <div>
                                    <FormControlLabel className="mr-2" value="unhidejoinHiddenField" control={<Radio />} label="Unhide Permanently" />
                                </div>
                                :
                                <>
                                </>
                            }
                        </RadioGroup>

                        <DialogActions className="btn-group">
                            <button color="primary" className="report_form_ui_btn submit" onClick={e => handleSubmit(e, measureDetails)}>Yes</button>

                            <button color="error" className="report_form_ui_btn cancel mr-2" onClick={toogleHideModal}>No</button>
                        </DialogActions>
                    </Box>

                </Modal>

            }

        </div>
    )

}


export default ManageDataset